// extracted by mini-css-extract-plugin
export default {"formulario":"Formulario_formulario__ozQtv"};